import React from 'react';
import { getLayoutProps } from 'src/helpers';
import { Label } from './Label';
import { StyledInput, StyledInputProps } from './StyledInput';

export type InputProps = StyledInputProps & {
  name?: string;
  label?: string;
  error?: boolean;
};

export const Input = React.forwardRef(({ label, disabled, children, inputProps, error, ...rest }: InputProps, ref) => {
  const [layoutProps, restStyledProps, restProps] = getLayoutProps(rest);

  return (
    <Label ref={ref} label={label} disabled={disabled} width={1} {...layoutProps}>
      <StyledInput
        error={error}
        disabled={disabled}
        {...inputProps}
        {...restStyledProps}
        {...restProps}
        data-testid={restProps['data-testid'] || 'react-select-data-testid-placeholder'}
      />
      {children}
    </Label>
  );
});
